<template>
  <div class="mx-3">
    <v-data-table :headers="headers" :items="users" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <h2>Registered users</h2>
          </v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.Enabled="{ item }">
        <!-- <v-chip :color="item.Enabled ? 'green' : 'yellow'">
          {{ item.Enabled ? 'Y' : 'N' }}
        </v-chip> -->
        <!-- {{ item.Enabled }} -->
        <v-icon color="red" v-if="item.Enabled" :disabled="item.Username === username" @click="disableUser(item)">
          mdi-cancel
        </v-icon>
        <v-icon v-else color="green" :disabled="item.Username === username" @click="enableUser(item)">
          mdi-check
        </v-icon>
      </template>
      <template v-slot:item.UserCreateDate="{ item }">
        {{ normalizeDate(item.UserCreateDate) }}
      </template>
      <template v-slot:item.UserLastModifiedDate="{ item }">
        {{ normalizeDate(item.UserLastModifiedDate) }}
      </template>
      <template v-slot:item.Actions="{ item }">
        <v-icon small class="mr-2" @click="editUser(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:item.Username="{ item }">
        {{ item.Username }}
        <v-dialog v-model="editDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Update cases for {{ item.Username }}</span>
            </v-card-title>
            <v-card-text>
              {{ selectedCases }}
              <v-row>
                <v-col v-for="c in cases" :key="c.caseId" cols="4">
                  <v-checkbox v-model="selectedCases" :label="c.caseId" :value="c.caseId"></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="editDialog = false">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="doUpdateUser">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <confirm-dialog ref="confirmDelete" />
      </template>
      <template v-slot:item.profile="{ item }">
        <v-btn style="width: 30px;" :class="item.profile === 'trial' ? 'amber' : 'success'" text small @click="updateProfile(item.Username, item.profile)">{{ item.profile }}</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// const AWS = require('aws-sdk')
import { mapGetters } from 'vuex'
import moment from 'moment'
import ConfirmDialog from '../Common/ConfirmDialog'

export default {
  components: {
    ConfirmDialog
  },
  data () {
    return {
      editDialog: false,
      selectedCases: [],
      headers: [
        { text: 'Username', value: 'Username' },
        // { text: 'Email', value: 'email' },
        { text: 'Create Date', value: 'UserCreateDate' },
        { text: 'Last Modify Date', value: 'UserLastModifiedDate' },
        { text: 'Status', value: 'UserStatus' },
        // { text: 'Cases', value: 'Cases' },
        { text: 'Account Type', value: 'profile', align: 'center' },
        // { text: 'Edit Account', value: 'Actions', align: 'center' },
        { text: 'Enable/Disable Account', value: 'Enabled', align: 'center' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      username: 'getUsername',
      cases: 'allCases',
      admins: 'getAdmins'
    })
  },
  methods: {
    normalizeDate: function (date) {
      return moment(date).fromNow()
    },
    editUser: function (u) {
      this.editDialog = true
      console.log(`Edit item ${JSON.stringify(u)}.`)
    },
    updateProfile: function (u, p) {
      const pn = p === 'trial' ? 'paid' : 'trial'
      const pd = {
        username: u,
        profile: pn
      }
      this.$store.dispatch('updateProfile', pd)
    },
    doUpdateUser: function (update) {
      console.log('Updating user....')
    },
    async disableUser (user) {
      if (
        await this.$refs.confirmDelete.open(
          'Disable user ' + user.Username,
          'Are you sure you want to disable the user?',
          {
            color: 'error'
          }
        )
      ) {
        this.$store.dispatch('disableUser', user.Username)
      }
    },
    async enableUser (user) {
      if (
        await this.$refs.confirmDelete.open(
          'Enable user ' + user.Username,
          'Are you sure you want to enable the user?',
          {
            color: 'primary'
          }
        )
      ) {
        this.$store.dispatch('enableUser', user.Username)
      }
    }
  },
  created () {
    // get list of users.
    this.$store.dispatch('fetchUsersFromCognito')
    this.$store.dispatch('changeShowToolbar', true)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Users.vue